// src/components/PdfOptionsModal.js
import React, { useState, useEffect } from 'react';
import './PdfOptionsModal.css';

function PdfOptionsModal({ visible, onClose, onGenerate }) {
  const [step, setStep] = useState('choose');      // 'choose' | 'pdf' | 'excel'
  const [includeWorkTime, setIncludeWorkTime] = useState(true);
  const [includeMaterials, setIncludeMaterials]   = useState(true);
  const [includePrice, setIncludePrice]           = useState(false);

  // reset stanów przy każdym otwarciu
  useEffect(() => {
    if (visible) {
      setStep('choose');
      setIncludeWorkTime(true);
      setIncludeMaterials(true);
      setIncludePrice(false);
    }
  }, [visible]);

  // wyłącz cenę gdy materiały OFF
  useEffect(() => {
    if (!includeMaterials) setIncludePrice(false);
  }, [includeMaterials]);

  if (!visible) return null;

  const renderChooseStep = () => (
    <>
      <h3>Wybierz format raportu</h3>

      <div className="format-buttons">
        <button className="btn-format" onClick={() => setStep('pdf')}>
          PDF
        </button>
        <button className="btn-format" onClick={() => setStep('excel')}>
          EXCEL
        </button>
      </div>
    </>
  );

  const renderPdfStep = () => (
    <>
      <h3>Wybierz sekcje do PDF</h3>
      <div className="pdf-options">
        <label>
          <input
            type="checkbox"
            checked={includeWorkTime}
            onChange={e => setIncludeWorkTime(e.target.checked)}
          />
          Czas Pracy
        </label>
        <label>
          <input
            type="checkbox"
            checked={includeMaterials}
            onChange={e => setIncludeMaterials(e.target.checked)}
          />
          Materiały
        </label>
        <label>
          <input
            type="checkbox"
            checked={includePrice}
            disabled={!includeMaterials}
            onChange={e => setIncludePrice(e.target.checked)}
          />
          Cena
        </label>
      </div>
      <div className="modal-buttons">
        <button
          className="btn-submit"
          onClick={() =>
            onGenerate({
              type: 'pdf',
              includeWorkTime,
              includeMaterials,
              includePrice,
            })
          }
        >
          Generuj PDF
        </button>
        <button className="btn-submit" onClick={onClose}>
          Anuluj
        </button>
      </div>
    </>
  );

  const renderExcelStep = () => (
    <>
      <h3>Generowanie raportu Excel</h3>
      <p className="excel-hint">
        Plik Excel będzie zawierał dane z wybranych zleceń w&nbsp;kolumnach
        odpowiadających bieżącej konfiguracji tabeli.
      </p>
      <div className="modal-buttons">
        <button
          className="btn-submit"
          onClick={() => onGenerate({ type: 'excel' })}
        >
          Generuj Excel
        </button>
        <button className="btn-submit" onClick={onClose}>
          Anuluj
        </button>
      </div>
    </>
  );

  return (
    <div className="modal-overlay">
      <div className="modal">
        {/* przycisk zamknięcia we wszystkich krokach */}
        <button className="btn-close" onClick={onClose}>
          ✕
        </button>

        {step === 'choose' && renderChooseStep()}
        {step === 'pdf'    && renderPdfStep()}
        {step === 'excel'  && renderExcelStep()}
      </div>
    </div>
  );
}

export default PdfOptionsModal;
